export const MONTH_DAY_CELL_PILLS_GAP = 6;
